import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Feedback() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="container">
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="post-apply-container">
            <h1 className="page-title">Feedback On Applications</h1>
            <p className="info-text">We know it's not ideal, and can be frustrating. You're building something you care deeply about, you put real time into applying, and it's natural to want specific feedback in return.</p>
            <p className="info-text">In practice, most apps aren't rejected for a clear, actionable reason.</p>
            <p className="info-text">LeapYear can only fund a small number of teams each cycle, which has our acceptance rate about 1%. We review every application carefully, and with a small, lean team, the time spent doing that directly trades off against the time required to write thoughtful, individualized feedback. Trying to do both would mean doing neither well.</p>
            <p className="info-text">Decisions are made under hard constraints: limited capital + limited time. Once capacity is filled, additional builders, many of them excellent, can't move forward.</p>
            <p className="info-text">As a result, rejection is not about a flaw in the application. It's about relative position. Small differences in timing, limited information, or how an application compares to others in the same cycle can make the difference.</p>
            <p className="info-text">Because of this, individualized feedback would often be speculative. We'd be guessing at reasons that may not actually explain the outcome, especially for stronger applications. That kind of feedback is more likely to mislead than help.</p>
            <p className="info-text">For that reason, we avoid application specific feedback. We'd rather be honest about the limits of the process than provide explanations that sound concrete but aren't. Our decisions are also not perfect. <Link to="/decisions" className="info-text-link">More on that here →</Link></p>
            <p className="info-text">We strongly encourage you to keep building. While we have limits on the number of teams we can fund, the world always needs more builders.</p>
            <p className="info-text">We also always welcome repeat applicants to LeapYear. We fund new teams every 3 months and historically, 25%+ of teams we've funded have been repeat applicants.</p>
            <br></br>
            <p className="info-text">Keep Building,</p>
            <p className="info-text">The LeapYear Team</p>
        </div>
    </main>
  );
}

export default Feedback;

